// extracted by mini-css-extract-plugin
module.exports = {"learnMoreList":"LearnMoreList_learnMoreList__yKAH6","secondary":"LearnMoreList_secondary__n0kaH","learnMoreItem":"LearnMoreList_learnMoreItem__oh7Qw"};